"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Types = exports.MIN_HEIGHT = exports.ColorSchema = void 0;
var MIN_HEIGHT = '54px';
exports.MIN_HEIGHT = MIN_HEIGHT;
var ColorSchema = {
  default: {
    iconColor: 'greyDark',
    borderColor: 'greyLight'
  },
  error: {
    iconColor: 'orange',
    borderColor: 'orange'
  }
};
exports.ColorSchema = ColorSchema;
var Types = Object.keys(ColorSchema);
exports.Types = Types;